import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image/mobile-google-play-badge.png")